import { useSelector } from 'react-redux';
import { trackClickSearchResults } from '@utils/Tracking/Search/trackSearchEvents';

/**
 * Custom hook to track search result clicks
 * @param highlightedResult - Whether the clicked result is a SearchInformationBox (highlighted result)
 * @returns An object containing trackClickSearchResult function to call when a search result is clicked
 */
export const useTrackSearchResultClick = (highlightedResult = false) => {
  const searchTerm = useSelector((state: any) => state.internalSiteSearch.submittedQuery);

  const trackClickSearchResult = () => {
    if (searchTerm) {
      trackClickSearchResults({
        searchTerm,
        highlightedResult,
      });
    }
  };

  return { trackClickSearchResult };
};
